<template>
  <v-dialog persistent v-model="intDialogVisible" max-width="100%" width="450">
    <base-material-card
      color="success"
      icon="mdi-hand-okay"
      title="Información de su licencia"
      class="px-5 py-3"
    >
      <v-card-text>
        <div class="body-2 text-uppercase mb-8">
          Su número de Licencia es :
          <span class="display-1">{{ data_key.value }}</span>
          <p>
            Fecha de creación de licencia
            {{ formatDate(data_key.creationDate) }}
          </p>
        </div>
        <v-divider></v-divider>
        <v-list-item-title>Su licencia tiene acceso a :</v-list-item-title>
        <template v-for="(item, i) in data_key.feature">
          <v-list-item three-line :key="i">
            <v-list-item-content>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
              <v-list-item-subtitle class="overline">{{
                item.description
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-card-text>
      <v-card-actions class="pl-0">
        <v-layout row wrap justify-center>
          <v-btn color="success" min-width="100" rounded @click="UseLicence"
            >Usar mi licencia ahora</v-btn
          >
          <v-btn
            min-width="100"
            rounded
            @click="$emit('close')"
            color="red darken-3"
            >Salir</v-btn
          >
        </v-layout>
      </v-card-actions>
    </base-material-card>
    <loader-dialog
      :mensajes="msj"
      :mensjae_="Mensaje"
      :showLoader="showLoader"
      @closeDialog="CloseDialog"
    />
    <!-- Llamar al modal para configurar negocio. -->
    <create-new-negocio
      :editing="true"
      :id="myId"
      :MyName="myName"
      :logo="myLogo"
      :dialog="newnegocio"
      @Close="Close"
      :persistent="true"
      @Terminado="Terminado"
    />

    <modal-sucursal
      :editing="true"
      :nombre_="nameSucursal"
      :branchId_="branchId"
      :mostrar="ModalSucursal"
      :persistent="true"
      :EditedItem="EditedItem"
      @finishHim="finishHim"
      @CerrarKey="CerrarModalBranch"
    />
  </v-dialog>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Swal from "sweetalert2";
import "sweetalert2/src/sweetalert2.scss";
import { mapGetters, mapState, mapMutations } from "vuex";
export default {
  components: {
    LoaderDialog: () => import("@/components/Loaders/_loader"),
    CreateNewNegocio: () => import("@/views/Admin/NuevoNegocio"),
    ModalSucursal: () => import("@/views/Admin/sucursal"),
  },
  props: {
    data_key: {
      type: Object,
    },
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      myId: 0,
      EditedItem: [],
      myName: "",
      nameSucursal: "",
      branchId: 0,
      myLogo: "",
      newnegocio: false,
      ModalSucursal: false,
      showLoader: false,
      msj: [
        {
          Msg: "Generando nuevo negocio",
        },
        {
          Msg: "Generando nueva sucursal",
        },
        {
          Msg: "Todo listo...",
        },
      ],
    };
  },
  computed: {
    ...mapState(["LoadAccountsM"]),
    Mensaje() {
      const _bussinessAccountId = parseInt(
        localStorage.getItem("_bussinessAccountId")
      );
      if (_bussinessAccountId == 0) {
        return "Generando nuevo negocio... Por favor espere.";
      } else {
        return "Creando nueva Sucursal.... Por favor espere.";
      }
    },
    intDialogVisible: {
      get: function () {
        if (this.dialog) {
        }
        return this.dialog;
      },
      set: function (value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    ...mapMutations({
      setLoadAccountsM: "SET_LOADACCOUNTS",
    }),
    CerrarModalBranch() {
      const bussinessAccountId_ = parseInt(
        localStorage.getItem("_bussinessAccountId")
      );
      this.ModalSucursal = false;

      if (bussinessAccountId_ == 0) {
        this.ReloadBussines();
      } else {
        this.ReloadBranch();
      }
      this.$emit("close");
    },
    finishHim() {
      const bussinessAccountId_ = parseInt(
        localStorage.getItem("_bussinessAccountId")
      );
      this.ModalSucursal = false;
      Swal.fire("Exito", "Exito al dar de alta el Negocio", "success");
      if (bussinessAccountId_ == 0) {
        this.ReloadBussines();
      } else {
        this.ReloadBranch();
      }
      this.$emit("close");
    },
    ReloadBranch() {
      let bussinessAccountId = localStorage.getItem("_bussinessAccountId");
      axios
        .get("/api/BranchOffice/GetByAccount/" + bussinessAccountId)
        .then((result) => {
          return result.data;
        })
        .then((data) => {
          this.$store.commit("SET_BRANCH", data);
        });
    },
    Close() {},
    ReloadBussines() {
      /*   axios
        .get("/api/Permissions/GetAccounts")
        .then(result => {
          if (result.status === 200) {
            this.$store.commit("SET_ACCOUNTS_", result.data);

            this.$store.dispatch("_SET_ACCOUNTS", true);
          }
        })
        .catch(err => {
          console.log(err.response);
        }); */
    },
    Terminado() {
      this.newnegocio = false;
      this.ModalSucursal = true;
    },
    CloseDialog() {
      this.showLoader = false;
    },
    formatDate(date) {
      return moment(String(date)).format("DD/MM/YYYY hh:mm");
    },
    UseLicence() {
      Swal.fire({
        title: "¿Confirmar el uso de su licencia ?",
        text: "Por favor confirme el uso de su licencia " + this.data_key.value,
        type: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, deseo usar mi licencia ahora. ! ",
        cancelButtonText: "No deseo usar mi licencia ahora. ! ",
      }).then((result) => {
        if (result.value) {
          this.showLoader = true;
          const bussinessAccountId_ = parseInt(
            localStorage.getItem("_bussinessAccountId")
          );

          axios
            .post("/api/BranchOffice/New", {
              bussinessAccountId: bussinessAccountId_,
              keyId: this.data_key.id,
              key: this.data_key.value,
            })
            .then((result) => {
              return result.data;
            })
            .then((data) => {
              this.ReloadBussines();
              this.setLoadAccountsM(true);
              this.$store.commit("SET_ACCOUNTS", true);

              Swal.fire({
                type: "success",
                title:
                  "Exito al crear " +
                  (bussinessAccountId_ == 0
                    ? " Negocio y sucursal"
                    : "Sucursal"),
                text:
                  "Se creo correctamente su  " +
                  (bussinessAccountId_ == 0
                    ? " nuevo negocio y sucursal "
                    : "nueva sucursal") +
                  " ¿Desea configurarlo ahora mismo? ",
                showCancelButton: true,
                confirmButtonColor: "#1B5E20",
                cancelButtonColor: "#B71C1C",
                confirmButtonText: "Sí, configurar ahora mismo. ! ",
                cancelButtonText: " No, configurar despues. ! ",
              }).then((result) => {
                if (result.value) {
                  this.EditedItem = [];
                  this.EditedItem.push(data);
                  if (bussinessAccountId_ == 0) {
                    this.$store.commit(
                      "SET_BUSSINES_ACOUNT_ID",
                      data.bussinessAccount.id
                    );
                    this.myId = data.bussinessAccount.id;
                    this.myName = data.bussinessAccount.name;
                    this.myLogo = data.bussinessAccount.logo;
                    this.nameSucursal = data.name;
                    this.branchId = data.id;
                    this.newnegocio = true;
                  } else {
                    this.ModalSucursal = true;
                    this.nameSucursal = data.name;
                    this.branchId = data.id;
                  }
                } else {
                  this.$emit("close");
                }
              });
            })
            .catch((err) => {
              this.showLoader = false;
              Swal.fire({
                title: "Error!!",
                text:
                  "Ooops... Algo salio mal al crear su " +
                  (bussinessAccountId_ == 0
                    ? " Negocio y sucursal"
                    : "Sucursal"),
                type: "error",
              });
            });

          /*  Swal.fire({
                  type:'success',
                  title : "Exito al crear " + ( _bussinessAccountId == 0 ? ' Negocio y sucursal': 'Sucursal') ,
                  text: "Se creo correctamente su  " + (_bussinessAccountId == 0 ? ' nuevo negocio y sucursal ': 'nueva sucursal' ) + ' ¿Desea configurarlo ahora mismo? ',
                   showCancelButton: true,
                  confirmButtonColor: "#1B5E20",
                  cancelButtonColor: "#B71C1C",
                  confirmButtonText: "Sí, configurar ahora mismo. ! ",
                  cancelButtonText: " No, configurar despues. ! "
                }).then(result =>{
                  if(result.value) {
                      alert("Ok Vamos a configurarlo")
                  }else {
                    this.$emit('close')

                  }
                })   */
        }
      });
    },
  },
};
</script>
